import { NgModule, inject } from '@angular/core';
import { IdleTimeoutService } from './idle-timeout.service';

@NgModule({
  providers: [IdleTimeoutService],
})
export class IdleTimeoutModule {
  private idleTimeoutService = inject(IdleTimeoutService)

  constructor () {
    this.idleTimeoutService.init()
  }
}
